import template from './overlap-conflict-modal.tpl.html'
import moment from 'moment'

class OverlapConflictModalController {
  constructor ($scope) {
    'ngInject'
    this._$scope = $scope
    this.localConflict = null
  }

  $onChanges (changes) {
    if (changes.conflict && this.conflict) {
      this.localConflict = angular.copy(this.conflict)
    }
  }

  formatDateTime (date) {
    return moment(date).format('HH:mm')
  }

  getMaxPriority (events) {
    if (!events || events.length === 0) return 0
    return Math.max(...events.map(e => e.extendedProps.priority || 0))
  }

  getMinPriority (events) {
    if (!events || events.length === 0) return 0
    return Math.min(...events.map(e => e.extendedProps.priority || 0))
  }

  selectConflictWinner (winner) {
    if (!this.localConflict) return

    this.localConflict.selectedEvent = winner

    const overlappingEvents = this.localConflict.overlappingEvents
    const maxPriority = this.getMaxPriority(overlappingEvents)
    const minPriority = this.getMinPriority(overlappingEvents)

    if (winner === 'dragged') {
      // New wins: priority = max + 1
      this.localConflict.calculatedPriority = maxPriority + 1
    } else {
      // Existing wins: priority = min - 1 (min 1)
      this.localConflict.calculatedPriority = Math.max(1, minPriority - 1)
    }
  }

  resolve () {
    this.onResolve({ $conflict: this.localConflict })
  }

  cancel () {
    this.onClose()
  }
}

export const OverlapConflictModalComponent = {
  template,
  controller: OverlapConflictModalController,
  bindings: {
    show: '<',
    conflict: '<',
    onClose: '&',
    onResolve: '&'
  }
}
